import React from "react";
import googleLogo from "../img/google.png";
import microsoftLogo from "../img/microsoft.png";
import { ssoUrls } from "../lib/sso.js";

export default class SsoButtons extends React.Component {
  /**
   * Initializes the SsoButtons component state.
   * @param {Object} props - React props.
   */
  constructor(props) {
    super(props);
    this.state = {
      btnType: 'none',
      btnTagline: '',
      btnPrefix: ''
    };
  }

  /**
   * React lifecycle method.
   * Sets up button text, classes, and URLs based on the type prop ("login" or "link").
   */
  componentDidMount = () => {
    if (this.props.type == 'login') {
      this.setState({
        btnType: 'login',
        btnPrefix: 'Log in with ',
        btnClass: "btn btn-auth d-flex align-items-center",
        btnContainer: "sso-button-container sso-login-button-container",
        googleUrl: (this.props.launchme ? ssoUrls.googleLoginUrl.replace("askey1", this.props.launchme) : ssoUrls.googleLoginUrl),
        microsoftUrl: (this.props.launchme ? ssoUrls.microsoftLoginUrl.replace("askey1", this.props.launchme) : ssoUrls.microsoftLoginUrl) 
      });
    }
    else {
      if (this.props.type == 'link') {

        this.setState({
          btnType: 'link',
          btnPrefix: 'Link with',
          btnClass: "btn btn-auth d-flex align-items-center",
          btnContainer: "d-flex justify-content-between sso-button-container",
          googleUrl: ssoUrls.googleLinkUrl,
          microsoftUrl: ssoUrls.microsoftLinkUrl,
          showWait: false,
          currentlyLinked: this.props.linked
        });
      }
    }
  };

  /**
   * Opens the SSO URL in a new tab.
   * If linking, calls the statuslisten callback to update SSO status.
   * @param {string} url - The SSO URL to open.
   */
  openWindow = (url) => {

    if (this.props.type == 'link') this.props.statuslisten();
    window.open(url, "_blank");
  };

  /**
   * Returns the CSS classes for the SSO button, highlighting if linked.
   * @param {number} btn - The provider identifier (1 for Google, 2 for Microsoft).
   * @returns {string} The CSS class string.
   */
  getButtonClasses = (btn) => {
    if (btn == this.props.linked && this.props.type == 'link') {
      return "btn btn-auth d-flex align-items-center btn-auth-active";
    }
    else {
      return "btn btn-auth d-flex align-items-center";
    }
  };

  //this.props.type = login or link
  /**
   * Renders the SSO buttons for Google and Microsoft.
   * @returns {JSX.Element}
   */
  render() {

    return (
      <div className={this.state.btnContainer}>

        <button href="#" className={this.getButtonClasses(2)} onClick={() => this.openWindow(this.state.microsoftUrl)}>
          <img alt={this.state.btnPrefix + " Microsoft"} className="auth-logos" src={microsoftLogo} /> <div className="text-center btn-text">{this.state.btnPrefix} Microsoft</div>
        </button>

        <button href="#" className={this.getButtonClasses(1)} onClick={() => { this.openWindow(this.state.googleUrl); console.log(this.state.googleUrl); }}>
          <img alt={this.state.btnPrefix + " Google"} className="auth-logos" src={googleLogo} /> <div className="text-center btn-text">{this.state.btnPrefix} Google</div>
        </button>

      </div>
    );
  }
}
